export interface IDkSsnProps {
	claimedSsn: string,
	day: number,
	month: number,
	year: number,
	century: number,
	age: number, // Also used to determine if valid.
	dob: Date
}

export function onlyNumbersPlease(dk: IDkSsnProps) {
	dk.claimedSsn = dk.claimedSsn.replace(/\D/g, '');
	return dk;
}

export function handleBaseDateData(dk: IDkSsnProps) {
	dk.day = Number(dk.claimedSsn.substring(0, 2));
	if (dk.day < 1 || dk.day > 31) dk.day = 0;

	dk.month = Number(dk.claimedSsn.substring(2, 4));
	if (dk.month < 1 || dk.month > 12) dk.month = 0;

	dk.year = Number(dk.claimedSsn.substring(4, 6));

	return dk;
}

export function validateDanishSsn(ssn: string) {
	const dk = {
		claimedSsn: ssn,
		day: 0,
		month: 0,
		year: 0, // Note that 0 is a perfectly valid year to be born in, e.g. 2000
		century: 0,
		age: 0,
		dob: new Date("1799-01-01")
	}

	onlyNumbersPlease(dk);
	if (!(dk.claimedSsn.match('^([0-9]){10}$'))) return dk;

	handleBaseDateData(dk);
	if (dk.day === 0 || dk.month === 0) return dk;

	const check = Number(dk.claimedSsn[6]);

	if (check <= 3)
		dk.century = 1900;

	if (check === 4)
		dk.century = dk.year <= 36 ? 2000 : 1900;

	if (check >= 5 && check <= 8)
		dk.century = dk.year <= 57 ? 2000 : 1800;

	if (check === 9)
		dk.century = dk.year <= 36 ? 2000 : 1900;

	if (dk.century === 0) return dk;

	dk.dob = new Date([dk.century + dk.year, dk.month, dk.day].join('-'));
	dk.age = Math.floor((new Date().getTime() - dk.dob.getTime()) / (86400 * 1000) / 365.25);

	return dk;
}
